import styled from "styled-components";

export const FAQWrapper = styled.section`
  /* padding: 80px 0; */
  width: 100%;
  min-width: 0;
`;

export const FAQContainer = styled.div`
  background: white;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #00585699;
  padding: 16px 26px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;

  @media (max-width: 560px) {
    padding: 18px 16px;
    border-radius: 18px;
  }
`;

export const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  flex-wrap: nowrap;

  @media (max-width: 560px) {
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }
`;

export const FAQAccent = styled.div`
  width: 6px;
  height: 42px;
  background: #f3a90d;
  border-radius: 999px;
  flex-shrink: 0;
  position: relative;
  left: -28px;

  @media (max-width: 560px) {
    left: -16px;
  }
`;

export const FAQTitle = styled.h2`
  flex: 1 1 0;
  min-width: 0;
  font-size: clamp(23px, 3vw, 32px);
  font-weight: 700;
  color: #115e63;
  text-align: left;
  white-space: normal;
  font-weight: 600;
  // overflow: hidden;
  // text-overflow: ellipsis;
  overflow-wrap: anywhere;
`;

export const AccordionItem = styled.div`
  background: white;
  border-radius: 28px;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
`;

export const AccordionHeader = styled.button`
  width: 100%;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  color: #1b3f84;
  gap: 12px;
  overflow-wrap: anywhere;

  @media (max-width: 560px) {
    padding: 16px 18px;
    font-size: 16px;
  }
`;

export const AccordionBody = styled.div`
  /* Keep answers in the document; disabling CSS reveals every answer. */
  display: ${({ $open }) => ($open ? "block" : "none")};
  padding: 30px 34px;
  background: #eef3f4;
  border-top: 1px solid #dbe3e5;
  color: #26457c;
  font-size: 18px;
  line-height: 1.7;
  overflow-wrap: anywhere;

  @media (max-width: 560px) {
    padding: 20px;
    font-size: 16px;
  }
`;

export const ViewAllButton = styled.button`
  background: transparent;
  color: #875f00;
  font-size: 22px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  flex-shrink: 0;

  @media (max-width: 560px) {
    margin-left: auto;
    font-size: 18px;
  }
`;
